import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

import styled from '@xstyled/styled-components';
import { Form, Radio, Skeleton } from 'antd';
import { useEffect, useMemo, useRef } from 'react';
import { AssignmentType } from '@module/assignment';
import { DefaultRadio } from '@lib/common';
import { CreatePracticeOptions, CreateExaminationOptions } from './options';
import { FieldLabel } from './field-label.component';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledFormInput = styled(Form)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  .ant-row {\n    margin-bottom: 4px;\n  }\n  .ant-form-item {\n    margin-bottom: 16px;\n  }\n  .ant-form-item-label {\n    font-weight: 500;\n    padding-bottom: 8px !important;\n  }\n  .ant-form-item-control-input {\n    min-height: auto;\n  }\n"])));
var StyledAssignmentTypeRadioGroup = styled(Radio.Group)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  gap: 12px;\n  flex-wrap: wrap;\n"])));
var StyledAssignmentTypeOption = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  border: 2px solid\n    ", ";\n  border-radius: 8px;\n  padding: 10px 12px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  background-color: ", ";\n  flex: 1;\n\n  &:hover {\n    border-color: ", ";\n    background-color: ", ";\n  }\n\n  .ant-radio {\n    margin-right: 8px;\n  }\n"])), function (props) {
  return props.selected ? props.theme.colors.fillIntActive : props.theme.colors.fillIntSubActive;
}, function (props) {
  return props.selected ? props.theme.colors.fillIntHighlighted : props.theme.colors.fillBgWhite;
}, function (props) {
  return props.theme.colors.fillIntActive;
}, function (props) {
  return props.selected ? props.theme.colors.fillIntHighlighted : props.theme.colors.fillBgSub;
});
var StyledAssignmentTypeOptionWrapper = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));
var StyledAssignmentTypeContent = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"])));
var StyledAssignmentTypeTitle = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-weight: 600;\n  font-size: 15px;\n  color: ", ";\n  margin-bottom: 2px;\n"])), function (props) {
  return props.theme.colors.contentTitle;
});
var StyledAssignmentTypeDescription = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-size: 13px;\n  color: ", ";\n  line-height: 1.35;\n"])), function (props) {
  return props.theme.colors.contentBody;
});
var StyledScrollableTabContent = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  flex: 1;\n  overflow-y: auto;\n  margin-bottom: 12px;\n  padding-right: 4px;\n"])));
export var CreateAssignmentForm = function CreateAssignmentForm(props) {
  var label = props.label,
      form = props.form,
      assignmentConfigsResponse = props.assignmentConfigsResponse,
      errorLabel = props.errorLabel,
      onFormValuesChange = props.onFormValuesChange,
      assignmentType = props.assignmentType,
      onToggleAllowToEditSubmission = props.onToggleAllowToEditSubmission,
      onToggleSelectUnlimitedEditSubmission = props.onToggleSelectUnlimitedEditSubmission,
      isUnlimitedEditSubmission = props.isUnlimitedEditSubmission,
      isAllowToEditSubmission = props.isAllowToEditSubmission,
      securityOptions = props.securityOptions,
      isLoadingGetSecurityOptions = props.isLoadingGetSecurityOptions,
      editorLabels = props.editorLabels,
      isModalVisible = props.isModalVisible,
      _props$hideAssignment = props.hideAssignmentTypeSelection,
      hideAssignmentTypeSelection = _props$hideAssignment === void 0 ? false : _props$hideAssignment,
      formTotalScore = props.formTotalScore;
  var scrollableContentRef = useRef(null);
  var wasModalVisibleRef = useRef(false);
  useEffect(function () {
    var isOpening = isModalVisible && !wasModalVisibleRef.current;
    wasModalVisibleRef.current = isModalVisible;

    if (!isOpening) {
      return;
    }

    var resetScroll = function resetScroll() {
      var _scrollableContentRef;

      return (_scrollableContentRef = scrollableContentRef.current) === null || _scrollableContentRef === void 0 ? void 0 : _scrollableContentRef.scrollTo({
        top: 0,
        left: 0
      });
    };

    resetScroll();
    var frameId = requestAnimationFrame(resetScroll);
    return function () {
      return cancelAnimationFrame(frameId);
    };
  }, [isModalVisible]);
  useEffect(function () {
    if (!isModalVisible || !assignmentConfigsResponse) {
      return;
    }

    var frameId = requestAnimationFrame(function () {
      var _scrollableContentRef2;

      (_scrollableContentRef2 = scrollableContentRef.current) === null || _scrollableContentRef2 === void 0 ? void 0 : _scrollableContentRef2.scrollTo({
        top: 0,
        left: 0
      });
    });
    return function () {
      return cancelAnimationFrame(frameId);
    };
  }, [assignmentConfigsResponse, isModalVisible]);

  var renderContentByAssignmentType = function renderContentByAssignmentType(type) {
    switch (type) {
      case AssignmentType.Practice:
        return /*#__PURE__*/_jsx(CreatePracticeOptions, {
          label: label,
          errorLabel: errorLabel,
          formTotalScore: formTotalScore,
          onFormValuesChange: onFormValuesChange
        });

      case AssignmentType.Examination:
        return /*#__PURE__*/_jsx(CreateExaminationOptions, {
          form: form,
          label: label,
          errorLabel: errorLabel,
          securityOptions: securityOptions,
          isLoadingGetSecurityOptions: isLoadingGetSecurityOptions,
          editorLabels: editorLabels,
          formTotalScore: formTotalScore,
          onFormValuesChange: onFormValuesChange
        });
    }
  };

  var assignmentTypeOptions = useMemo(function () {
    return [{
      label: label.practice,
      value: AssignmentType.Practice,
      description: label.practiceDescription
    }, {
      label: label.examination,
      value: AssignmentType.Examination,
      description: label.examinationDescription
    }];
  }, [label]);

  var renderFormContent = function renderFormContent() {
    if (!assignmentConfigsResponse) {
      return /*#__PURE__*/_jsx(Skeleton, {
        active: true,
        paragraph: {
          rows: 8
        }
      });
    }

    var assignmentOptions = assignmentTypeOptions.map(function (option, index) {
      return /*#__PURE__*/_jsx(StyledAssignmentTypeOption, {
        selected: assignmentType === option.value,
        onClick: function onClick() {
          form.setFieldsValue({
            type: option.value
          });
          onFormValuesChange();
        },
        children: /*#__PURE__*/_jsxs(StyledAssignmentTypeOptionWrapper, {
          children: [/*#__PURE__*/_jsx(DefaultRadio, {
            value: option.value
          }), /*#__PURE__*/_jsxs(StyledAssignmentTypeContent, {
            children: [/*#__PURE__*/_jsx(StyledAssignmentTypeTitle, {
              children: option.label
            }), /*#__PURE__*/_jsx(StyledAssignmentTypeDescription, {
              children: option.description
            })]
          })]
        })
      }, index);
    });
    return /*#__PURE__*/_jsxs(StyledFormInput, {
      form: form,
      layout: "vertical",
      onValuesChange: onFormValuesChange,
      requiredMark: false,
      children: [!hideAssignmentTypeSelection && /*#__PURE__*/_jsx(Form.Item, {
        name: "type",
        label: /*#__PURE__*/_jsx(FieldLabel, {
          label: label.type,
          hint: label.typeHint
        }),
        children: /*#__PURE__*/_jsx(StyledAssignmentTypeRadioGroup, {
          defaultValue: assignmentType,
          children: assignmentOptions
        })
      }), /*#__PURE__*/_jsx(StyledScrollableTabContent, {
        ref: scrollableContentRef,
        children: renderContentByAssignmentType(assignmentType)
      })]
    });
  };

  return renderFormContent();
};